var _rect, _rect2, _mask, _path, _path2, _mask2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFilterMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    fill: "#F5FAFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#4DA9FF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1_1922",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8546 13.75C12.5579 14.483 11.8393 15 11 15C9.89543 15 9 14.1046 9 13C9 11.8954 9.89543 11 11 11C11.8393 11 12.5579 11.517 12.8546 12.25L22 12.25C22.4142 12.25 22.75 12.5858 22.75 13C22.75 13.4142 22.4142 13.75 22 13.75L12.8546 13.75Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8546 13.75C12.5579 14.483 11.8393 15 11 15C9.89543 15 9 14.1046 9 13C9 11.8954 9.89543 11 11 11C11.8393 11 12.5579 11.517 12.8546 12.25L22 12.25C22.4142 12.25 22.75 12.5858 22.75 13C22.75 13.4142 22.4142 13.75 22 13.75L12.8546 13.75Z",
    fill: "#4DA9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8546 13.75V12.75L12.1806 12.75L11.9277 13.3748L12.8546 13.75ZM12.8546 12.25L11.9277 12.6252L12.1806 13.25H12.8546V12.25ZM22 12.25V11.25V12.25ZM22 13.75V14.75V13.75ZM11.9277 13.3748C11.7786 13.7431 11.4181 14 11 14V16C12.2606 16 13.3373 15.2228 13.7816 14.1252L11.9277 13.3748ZM11 14C10.4477 14 10 13.5523 10 13H8C8 14.6569 9.34315 16 11 16V14ZM10 13C10 12.4477 10.4477 12 11 12V10C9.34315 10 8 11.3431 8 13H10ZM11 12C11.4181 12 11.7786 12.2569 11.9277 12.6252L13.7816 11.8748C13.3373 10.7772 12.2606 10 11 10V12ZM12.8546 13.25L22 13.25V11.25L12.8546 11.25V13.25ZM22 13.25C21.8619 13.25 21.75 13.1381 21.75 13H23.75C23.75 12.0335 22.9665 11.25 22 11.25V13.25ZM21.75 13C21.75 12.8619 21.8619 12.75 22 12.75V14.75C22.9665 14.75 23.75 13.9665 23.75 13H21.75ZM22 12.75L12.8546 12.75V14.75L22 14.75V12.75Z",
    fill: "#4DA9FF",
    mask: "url(#path-2-inside-1_1_1922)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_1_1922",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 21C22.1046 21 23 20.1046 23 19C23 17.8954 22.1046 17 21 17C20.1607 17 19.4421 17.517 19.1454 18.25L10 18.25C9.58579 18.25 9.25 18.5858 9.25 19C9.25 19.4142 9.58579 19.75 10 19.75L19.1454 19.75C19.4421 20.483 20.1607 21 21 21Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 21C22.1046 21 23 20.1046 23 19C23 17.8954 22.1046 17 21 17C20.1607 17 19.4421 17.517 19.1454 18.25L10 18.25C9.58579 18.25 9.25 18.5858 9.25 19C9.25 19.4142 9.58579 19.75 10 19.75L19.1454 19.75C19.4421 20.483 20.1607 21 21 21Z",
    fill: "#4DA9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1454 18.25V19.25H19.8194L20.0723 18.6252L19.1454 18.25ZM10 18.25L10 17.25H10V18.25ZM10 19.75L10 18.75H10V19.75ZM19.1454 19.75L20.0723 19.3748L19.8194 18.75L19.1454 18.75V19.75ZM22 19C22 19.5523 21.5523 20 21 20V22C22.6569 22 24 20.6569 24 19H22ZM21 18C21.5523 18 22 18.4477 22 19H24C24 17.3431 22.6569 16 21 16V18ZM20.0723 18.6252C20.2214 18.2569 20.5819 18 21 18V16C19.7394 16 18.6627 16.7772 18.2184 17.8748L20.0723 18.6252ZM10 19.25L19.1454 19.25V17.25L10 17.25L10 19.25ZM10.25 19C10.25 19.1381 10.1381 19.25 10 19.25V17.25C9.0335 17.25 8.25 18.0335 8.25 19H10.25ZM10 18.75C10.1381 18.75 10.25 18.8619 10.25 19H8.25C8.25 19.9665 9.0335 20.75 10 20.75V18.75ZM19.1454 18.75L10 18.75L10 20.75L19.1454 20.75V18.75ZM21 20C20.5819 20 20.2214 19.7431 20.0723 19.3748L18.2184 20.1252C18.6627 21.2228 19.7394 22 21 22V20Z",
    fill: "#4DA9FF",
    mask: "url(#path-4-inside-2_1_1922)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFilterMedium);
export default __webpack_public_path__ + "static/media/ic_filter_medium.af4f8417fe8611fee0be2aed4d3f6b8a.svg";
export { ForwardRef as ReactComponent };